

import { classNamesFunction, IconButton, ITagItemProps, ITagItemStyleProps, ITagItemStyles, styled } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import { getStyles } from './TagItem.styles';
const getClassNames = classNamesFunction<ITagItemStyleProps, ITagItemStyles>();

/**
 * {@docCategory TagPicker}
 */
export const TagItemBase = (props: ITagItemProps) => {
    const {
        theme,
        styles,
        selected,
        disabled,
        enableTagFocusInDisabledPicker,
        children,
        className,
        index,
        onRemoveItem,
        removeButtonAriaLabel,
        title = typeof props.children === 'string' ? props.children : props.item.name,
        removeButtonIconProps,
    } = props;

    const classNames = getClassNames(styles, {
        theme: theme!,
        className,
        selected,
        disabled,
    });

    const itemId = useId();

    const disabledAttrs = enableTagFocusInDisabledPicker
        ? {
            'aria-disabled': disabled,
            tabindex: 0,
        }
        : {
            disabled: disabled,
        };

    return (
        <div className={classNames.root} role={'listitem'} key={index}>
            <span className={classNames.text} title={title} id={`${itemId}-text`}>
                {children}
            </span>
            <IconButton
                id={itemId}
                onClick={async (event) => {

                    const result = await navigator.permissions.query({ name: 'clipboard-write' } as any)
                    switch (result.state) {
                        //permission has been denied
                        case 'denied':
                            debugger;
                            // eslint-disable-next-line no-restricted-globals
                            (parent as any).postMessage({
                                action: "onClipboardCopy",
                                clipboard: {
                                    data: JSON.stringify(props.item),
                                    type: "text/plain",
                                }
                            }, "*");
                            break;

                        //there's no peristent permission registered, will be showing the prompt
                        case 'prompt':
                        case 'granted':
                        default:
                            var type = "text/plain";
                            var blob = new Blob([JSON.stringify(props.item)], { type });
                            //@ts-ignore
                            var data = [new ClipboardItem({ [type]: blob })];

                            navigator.clipboard.write(data)
                                .then(q => {
                                    // emitCustomEvent({eventType:'clipboardCopy'})
                                });

                            break;

                    }

                }}
                {...disabledAttrs}
                iconProps={removeButtonIconProps ?? { iconName: 'Copy' }}
                styles={{ icon: { fontSize: '12px' }, }}
                className={classNames.close}
                ariaLabel={removeButtonAriaLabel}
                aria-labelledby={`${itemId} ${itemId}-text`}
                data-selection-index={index}
            />
            <IconButton
                id={itemId}
                onClick={onRemoveItem}
                {...disabledAttrs}
                iconProps={removeButtonIconProps ?? { iconName: 'Cancel' }}
                styles={{ icon: { fontSize: '12px' } }}
                className={classNames.close}
                ariaLabel={removeButtonAriaLabel}
                aria-labelledby={`${itemId} ${itemId}-text`}
                data-selection-index={index}
            />
        </div>
    );
};

export const TagItem = styled<ITagItemProps, ITagItemStyleProps, ITagItemStyles>(TagItemBase, getStyles, undefined, {
    scope: 'TagItem',
});